module.exports = __webpack_public_path__ + "img/login.7502cdaf.png";